export default {
  SET_HIGHLIGHTED_OFFERS: (state, highlightedOffers) => (state.highlightedOffers = highlightedOffers),
}
